/**
 * @generated SignedSource<<c855fa26406ab1a5bb404801fabbc15c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedBuyerIncentives_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedBuyerProtection_user">;
  readonly " $fragmentType": "PdpSharedBuyerIncentives_user";
};
export type PdpSharedBuyerIncentives_user$key = {
  readonly " $data"?: PdpSharedBuyerIncentives_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedBuyerIncentives_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedBuyerIncentives_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedBuyerProtection_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "6f3e143f349f74c6acb3d9bbdfa3c0f0";

export default node;
